import { render, staticRenderFns } from "./screen1.vue?vue&type=template&id=3ead4e34&"
import script from "./screen1.vue?vue&type=script&lang=js&"
export * from "./screen1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports